import * as z from "zod";

export const numericOptionSchema = {
  value: z.number(),
  label: z.string(),
};
